import React, { Component, useRef, useState } from "react";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactSignatureCanvas from "react-signature-canvas";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { calculateDateDifference } from "../../utils/miscHelper";
import styles from "./Preview.modules.scss";

const StaticFiles = (props) => {
  const { documentSections, document, redirectToList } = props;

  const [trimmedDataURL, setTrimmedDataURL] = useState("");
  const [showSignModal, setShowSignModal] = useState(false);
  const { t } = useTranslation();
  const sigpad = useRef(null);
  const dateDifference = calculateDateDifference(new Date(), document.document.expiryDate);
  const [isSigningDocument, setIsSigningDocument] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const addTouchSignatureDoc = () => {
    let sectionTobeSigned = documentSections.filter((e) => e.isSectionSignatureRequired === true);
    let sectionsSigned = documentSections.filter((e) => e.sectionSignedHtml !== null);
    if (sectionsSigned.length === sectionTobeSigned.length) {
      setShowSignModal(true);
      setTrimmedDataURL("");
    }
    // else {
    //   setAlert(true);
    // }
  };

  const clear = () => {
    sigpad.current.clear();
    setTrimmedDataURL("");
  };

  const onModalClose = () => {
    setShowSignModal(false);
  };

  const updateStates = (documentId) => {
    if (documentId) {
      setIsSigningDocument(true);
    }
    props.updateStates(null, trimmedDataURL).then((result) => {
      if (result) {
        if (result.alert) {
          onModalClose();
          // setAlert(true);
        } else {
          onModalClose();
          redirectToList();
        }
      } else {
        onModalClose();
      }
      if (documentId) {
        setIsSigningDocument(false);
      }
    });
  };

  const onDocViewerLoad = (response) => {
    setIsLoading(response);
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-8 col-md-9" style={{ paddingTop: "1px", fontSize: "22px", color: "brown" }}>
        {document.document.name}
      </div>
      <div className="col-xs-12 col-sm-4 col-md-3">
        <Button
          variant="outline-secondary"
          disabled={isLoading}
          onClick={redirectToList}
          style={{ width: "165px", border: "1px solid #DDD", padding: "10px" }}>
          {t("Action.Back")}
        </Button>
      </div>
      {/* <Loading className="loading-component" isLoading={this.state.isLoading || this.props.loading} /> */}
      <div style={{ marginTop: "80px" }}>
        {/* <embed src={document.document.url} width="100%" height="700px" alt="pdf" /> */}
        <DocsViewer width="100%" height="700px" fileUrl={document.document.url} onLoad={onDocViewerLoad} />
      </div>
      {document.document.isDocumentSingReqested && document.document.status !== 3 && (
        <div
          className="row col-xs-12 col-sm-12 col-md-12"
          style={{ width: "103%", height: "80px", marginTop: "15px", backgroundColor: "#EFEFEF" }}>
          <div
            className="col-xs-12 col-md-6 col-md-6"
            style={{ padding: "21px 0px 10px 59px", fontSize: "22px", fontWeight: "500" }}>
            <span>{t("AgreementDocuments.agreementDocumentAcceptMessagee")}</span>
          </div>
          <div className="col-xs-8 col-md-6 col-md-6" style={{ padding: "13px" }}>
            {dateDifference < 0 && (
              <div>
                <Button disabled style={{ width: "165px", border: "1px solid #DDD" }}>
                  {t("Action.AgreeSign")}
                </Button>
                <OverlayTrigger
                  placement="right"
                  trigger={["click", "hover", "focus"]}
                  overlay={
                    <Tooltip id="adddocument.conditions.exclude">
                      {t("AgreementDocuments.expiredDocumentsMessage")}
                    </Tooltip>
                  }>
                  <span style={{ display: "inline", padding: "7px" }}>
                    <i className="glyphicon glyphicon-info-sign" />
                  </span>
                </OverlayTrigger>
              </div>
            )}
            {document.document.isDocumentSingReqested && dateDifference > 0 && (
              <div className={`row ${styles.p10}`}>
                {document.document.isTouchSignatureUI ? (
                  <Button
                    disabled={isSigningDocument}
                    style={{ display: "block", float: "right" }}
                    variant="success"
                    size="sm"
                    onClick={() => addTouchSignatureDoc()}>
                    {`Click here to sign `}
                  </Button>
                ) : (
                  <Button
                    onClick={() => updateStates(document.id)}
                    style={{ width: "165px", border: "1px solid #DDD" }}>
                    {t("Action.AgreeSign")}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      <Modal show={showSignModal} onHide={onModalClose} backdrop="static">
        <Modal.Header closeButton className="brand-primary">
          <Modal.Title>{"Draw your signature here"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <ReactSignatureCanvas
              penColor="black"
              backgroundColor="white"
              canvasProps={{ height: 100, width: 500 }}
              ref={sigpad}
              onEnd={() => {
                const imageData = sigpad.current.getTrimmedCanvas().toDataURL("image/png");
                setTrimmedDataURL(imageData);
              }}
            />
            <div className="row">
              <div className="col-md-12">
                <Button variant="danger" onClick={clear}>
                  Clear
                </Button>

                <Button variant="success" className="pull-right" disabled={trimmedDataURL === ""} onClick={updateStates}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

class DocsViewer extends Component {
  constructor(props) {
    super();
    this.bindActions();
    this.iFrameRef = null;
    this.state = {
      loaded: false,
    };
    this.setiFrameInputRef = (element) => {
      this.iFrameRef = element;
    };
  }
  bindActions() {
    this.updateIframeSrc = this.updateIframeSrc.bind(this);
    this.iframeLoaded = this.iframeLoaded.bind(this);
  }

  iframeLoaded() {
    clearInterval(this.iframeTimeoutId);
    this.setState({
      loaded: true,
    });
    this.props.onLoad(false);
  }

  getIframeLink() {
    const url = encodeURIComponent(this.props.fileUrl);
    return `https://docs.google.com/viewer?url=${url}&embedded=true`; // no need for this if thats not dynamic
  }

  updateIframeSrc() {
    if (this.iFrameRef) {
      this.iFrameRef.src = this.getIframeLink();
    }
  }

  componentDidMount() {
    this.iframeTimeoutId = setInterval(this.updateIframeSrc, 1000 * 3);
  }

  render() {
    const style = {
      width: this.props.width,
      height: this.props.height,
      border: "none",
      overflow: "scroll",
    };
    return (
      <div>
        {!this.state.loaded && <div style={{ textAlign: "center" }}> Loading...</div>}
        <div>
          <iframe
            className="customScrollbar"
            style={style}
            onLoad={this.iframeLoaded}
            onError={this.updateIframeSrc}
            ref={this.setiFrameInputRef}
            src={this.getIframeLink()}></iframe>
        </div>
      </div>
    );
  }
}

StaticFiles.propTypes = {
  documentSections: PropTypes.array.isRequired,
  document: PropTypes.object.isRequired,
  redirectToList: PropTypes.func.isRequired,
  updateStates: PropTypes.func.isRequired,
};

export default StaticFiles;
